import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { resultsConfigSelector } from 'ctm-selectors';

import { interpolateString } from 'ctm-util-functions';

/**
 * Displays a Text Component with interpolated template
 * @type {Object} label Label text template
 * @type {Object} product product to be passed into the template
 * @type {String} filtername the filtername to be passed into the template
 * @returns {NoQuoteText} A NoQuoteText Component
 */
class _FilteredOutText extends PureComponent {

    /**
     * Finds {stateKey} in a string and returns the string along with content replaced from state.
     * @param {String} label Label text with replacement stateKey
     * @param {Object} product Product from stateProps
     * @param {String} filter the filter statekey
     * @param {String} filterSchema the filter schema
     * @returns {String} Label string with replaced content
     */
    getLabel = (label, product, filter, filterSchema) => {
        const { resultsConfig } = this.props;
        const { filterName } = filterSchema;
        const filterValue = resultsConfig.getIn(['filters', filter]);

        return interpolateString(label || '')({ product, filterValue, filterName });
    };

    render = () => {
        const { label, stateProps } = this.props;
        const { product, filter, filterSchema } = stateProps;

        return (
            <span>{this.getLabel(label, product, filter, filterSchema)}</span>
        );
    };

}

_FilteredOutText.propTypes = {
    label: PropTypes.string,
    stateProps: PropTypes.shape({
        product: PropTypes.object.isRequired,
        filterSchema: PropTypes.object.isRequired,
        filter: PropTypes.string
    }),
    resultsConfig: PropTypes.object
};

const mapStateToProps = (state) => {
    const resultsConfig = resultsConfigSelector(state);
    return {
        resultsConfig
    };
};

const FilteredOutText = connect(mapStateToProps)(_FilteredOutText);
export { FilteredOutText, _FilteredOutText };
